import React, { useContext } from 'react';
import { styled, Theme } from '@staffino/primitive-controls';
import SettingsContext from '../settings-context';

const StarSvg = styled.svg({
  width: '100%',
  height: 'auto',
  maxWidth: '3.875rem',
  maxHeight: '3.875rem',
  cursor: 'pointer',
  transition: 'color 0.3s linear, margin 0.15s ease-out',
});

const StyledLabel = styled.label<{
  color: string;
  width: string;
  highlighted: boolean;
  theme?: Theme;
}>((props) => ({
  color: props.highlighted ? props.color : props.theme.colors.separator,
  position: 'relative',
  bottom: 0,
  transition: 'bottom 0.2s ease-out',
  width: props.width,
  textAlign: 'center',
  touchAction: 'none',
  'input:checked + &': {
    color: props.color,
  },
  // hover for devices with cursor only
  '@media (hover: hover) and (pointer: fine)': {
    '&:hover': {
      position: 'relative',
      bottom: 10,
      transition: 'bottom 0.2s ease-out',
      color: '#b6c7da',
    },
  },
  // this shows hover animations by :active for mobiles and tablets
  '&:active': {
    position: 'relative',
    bottom: 10,
    transition: 'bottom 0.2s ease-out',
    color: '#b6c7da',
  },
}));
const HiddenRadio = styled.input({
  position: 'absolute',
  width: 0,
  height: 0,
  opacity: 0,
});

export default function StarButton({
  score,
  color,
  name,
  width,
  innerRef,
  onChange,
  highlighted,
}) {
  const { contextMenuEventIsClick } = useContext(SettingsContext);
  const handleContextMenu = (event: React.SyntheticEvent) => {
    if (contextMenuEventIsClick) {
      // treat context menu events as clicks
      event.preventDefault();
      onChange?.(score);
    }
  };
  return (
    <>
      <HiddenRadio
        ref={innerRef}
        type="radio"
        name={name}
        defaultValue={score}
        id={`${name}.${score}`}
        onChange={() => onChange?.(score)}
      />
      <StyledLabel
        htmlFor={`${name}.${score}`}
        color={color}
        width={width}
        highlighted={highlighted}
        onContextMenu={handleContextMenu}
      >
        <StarSvg
          // Stolen from FontAwesome and react-icons
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 576 512"
          height="1em"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          {highlighted ? (
            <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" />
          ) : (
            <path d="M 528.1 171.5 L 382 150.2 L 316.7 17.8 C 305 -5.8 271.1 -6.1 259.3 17.8 L 194 150.2 L 47.9 171.5 C 21.7 175.3 11.2 207.6 30.2 226.1 L 135.9 329.1 L 110.9 474.6 C 106.4 500.9 134.1 520.6 157.3 508.3 L 288 439.6 L 418.7 508.3 C 441.9 520.5 469.6 500.9 465.1 474.6 L 440.1 329.1 L 545.8 226.1 C 564.8 207.6 554.3 175.3 528.1 171.5 Z M 413.246 321.142 L 442.568 491.554 L 288.232 413.651 L 132.948 492.016 L 162.516 318.612 L 36.223 197.715 L 210.137 173.067 L 287.674 17.63 L 364.644 172.095 L 537.458 198.334 L 413.246 321.142 Z" />
          )}
        </StarSvg>
      </StyledLabel>
    </>
  );
}
